import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { HeaderService } from 'src/app/shared/services/header/header.service';
import { CopyService } from 'src/app/shared/services/copies/copy.service';
import { NavigationService } from 'src/app/shared/services/navigation/navigation-onboarding.service';
import { BitacoraService } from 'src/app/shared/services/bitacora/bitacora.service';
import { AbreCuentasService } from 'src/app/shared/services/abre-cuentas/abre-cuentas.service';
import { ParametersService } from 'src/app/shared/services/parameters/parameters.service';
import { OpEnum } from 'src/app/shared/enums/op.enum';
import { BUSINESS_CONST } from 'src/app/shared/constants/business.constants';
import { MinValueModel } from 'src/app/shared/models/common.model';

@Component({
  selector: 'app-edith-offert',
  templateUrl: './edith-offert.component.html',
  styleUrls: ['./edith-offert.component.scss'],
})
export class EdithOffertComponent implements OnInit {
  config = {
    allowNegative: false,
    decimal: ',',
    precision: 0,
    thousands: '.',
    prefix: '$ ',
  };
  dataProducts;
  product_type: string;
  productsMulti: any;
  type;
  text: any = {};
  formGroup: FormGroup;
  min;
  max;
  textInformation = '';
  modifiedValue: any;
  minAmount: MinValueModel;
  constructor(
    private headerService: HeaderService,
    private navigationService: NavigationService,
    public copyService: CopyService,
    private formBuilder: FormBuilder,
    private bitacoraService: BitacoraService,
    private abreCuentasService: AbreCuentasService,
    private parametersService: ParametersService,
  ) {
    this.headerService.show(true, true, true);
    this.formGroup = this.formBuilder.group({
      newValue: [],
    });
  }

  ngOnInit() {
    this.product_type = this.abreCuentasService.getEditProduct();
    this.validateLimits();
    this.validatorFormGroup();
    this.text = this.copyService.copies.edith_offer;
    const money = Intl.NumberFormat('es-EN');
    this.textInformation = `${this.text.min} $${money.format(this.min)} ${this.text.max} $${money.format(this.max)}`;
    this.formGroup.controls.newValue.valueChanges.subscribe((res: any) => {
      if (this.max < Number(res)) {
        this.textInformation = `${this.text.maxError} $${money.format(this.max)}`;
      } else {
        this.textInformation = `${this.text.min} $${money.format(this.min)} ${this.text.max} $${money.format(this.max)}`;
      }
    });
  }

  next() {
    let modifiedValue = this.formGroup.value.newValue;
    modifiedValue = modifiedValue.split('.');
    this.bitacoraService.saveDataInBitacora('approved_quota_' + this.abreCuentasService.getAmout(this.product_type));
    this.bitacoraService.saveDataInBitacora('modified_quota_' + modifiedValue[0]);
    this.abreCuentasService.setAmout(this.product_type, modifiedValue[0]);
    this.navigationService.nextStep('200');
  }

  validateLimits() {
    let producTypeEdit = this.abreCuentasService.getEditProduct();
    this.productsMulti = this.abreCuentasService.getProductsSelects();
    this.productsMulti.forEach(products => {
      if (products.product_type === producTypeEdit) {
        this.minAmount = products.product_type === BUSINESS_CONST.PRODUCT_TYPE_TC ? this.parametersService.getSetting(OpEnum.MULTIPLE_PRODUCT_TC_LIMITS) : this.parametersService.getSetting(OpEnum.MULTIP_OFFERT_C_ROTATIVO);
        this.min = this.minAmount ? this.minAmount.minimumAmount : '';
        this.max = this.abreCuentasService.getAmout(products.product_type);
      }
    });
  }
  validatorFormGroup() {
    this.formGroup = this.formBuilder.group({
      newValue: [this.modifiedValue ? this.modifiedValue : 0, [Validators.required, Validators.min(this.min), Validators.max(this.max)]],
    });
  }
}
